import { Text } from 'hb-react/shared/components/formik/components/inputs';

export const Company = () => (
  <Text
    id="company_name"
    label={s__('JobForm|Organization name')}
    name="company_name"
    placeholder={s__('JobForm|Organization issuing the opportunity')}
  />
);
